import { Link, useHistory } from "react-router-dom";
import { setValToLS } from "../helpers";

const Nav = ({ on, user }) => {
	const history = useHistory();

	const handleSignout = () => {
		setValToLS("vtoUserToken", null);
		history.push("/");
	};

	return (
		<>
			{user && (
				<div className="steps" style={{ paddingBottom: "5px" }}>
					<h4>{`Welcome, ${user.fname}`}</h4>

					<button
						type="button"
						className="btn-alt"
						onClick={() => handleSignout()}
					>
						Sign Out
					</button>

					<ol>
						{[
							{
								id: 1,
								name: "Generate Reports",
								link: "/admin/csv",
							},
							{
								id: 2,
								name: "Registration Snapshot",
								link: "/admin/snapshot",
							},
							{
								id: 3,
								name: "Record a Payment",
								link: "/admin/payment",
							},
							{
								id: 4,
								name: "Assign Venues to Foursomes",
								link: "/admin/venues",
							},
							{
								id: 5,
								name: "Guest Information",
								link: "/admin/guest",
							},
							{
								id: 6,
								name: "Create & Send Email",
								link: "/admin/email",
							},
							{
								id: 7,
								name: "Hotel Management",
								link: "/admin/hotel",
							},
							{
								id: 8,
								name: "Printable Invoices",
								link: "/admin/invoices",
							},
							{
								id: 9,
								name: "Registration Links",
								link: "/admin/links",
							},
						].map((item) => {
							return (
								<li className={item.id === on ? "selected" : ""} key={item.id}>
									<Link to={item.link}>{item.name}</Link>
								</li>
							);
						})}
					</ol>
				</div>
			)}

			<div className="blocktext" style={{ marginTop: "20px" }}>
				Questions? Please contact Kylan at (561) 719-3855 or email{" "}
				<a href={`mailto:kylan@qnewmedia.com`}>kylan@qnewmedia.com</a>.
			</div>
		</>
	);
};

export default Nav;
